import { t } from 'i18next';

import { LineItemTypeOption } from '~hooks/useRutter/models';

enum QuickBooksLineItemType {
  FreightRateLineItem = 'FreightRateLineItem',
  MaterialRateLineItem = 'MaterialRateLineItem',
}

type LineItemTypeLabelSource = Pick<LineItemTypeOption, 'name'>;

const PREFIX = 'administration.integration.rutter.quick_books_online.grid';

export const formatLineItemTypeLabel = (lineItemTypeOption: LineItemTypeLabelSource) => {
  switch (lineItemTypeOption.name) {
    case QuickBooksLineItemType.FreightRateLineItem:
      return t(`${PREFIX}.line_item_type_freight`);
    case QuickBooksLineItemType.MaterialRateLineItem:
      return t(`${PREFIX}.line_item_type_material`);
    default:
      return lineItemTypeOption.name;
  }
};
